import { getFireStoreSkpApiSettings } from '../firestore/getGdeSkpApiSettings'
import { HTTP_POST, RETRY_LATER } from '../common/appConstants'
import { invokeWsgRequest } from '../common/wsgCall'
import { getSkpApiJWT, setSkpApiJWT } from '../../redux/global'

/**
 * 
 * @returns {object} wsg header for skp api services
 */
export const wsgSkpApiHeader = async () => {
  const skpApiSettings = await getFireStoreSkpApiSettings()
  const loginHeaders = skpApiSettings.data().loginHeaders
  const apiUrl = skpApiSettings.data().skpApiWsgBaseUrl + skpApiSettings.data().endpoints.login
  const jwtResponse = await getSkpApiJWTHeaderToken(apiUrl, {}, {}, loginHeaders)
  const skpApiHeader = skpApiSettings.data().headers
  skpApiHeader.JWT = jwtResponse
  return skpApiHeader
}

/**
 * 
 * @param {string} apiUrl login url to get jwt token
 * @param {object} requestBody if any request body need to be assign
 * @param {object} params path/query param details
 * @param {object} headers request header info
 * @returns {string} return JWT token or error 
 */
export const getSkpApiJWTHeaderToken = async (apiUrl, requestBody, params, headers) => {
  let response
  if (!getSkpApiJWT()) {
    response = await invokeWsgRequest(HTTP_POST, apiUrl, requestBody, params, headers)
  } else {
    return getSkpApiJWT()
  }
  if ('JWT' in response && !('errors' in response)) {
    setSkpApiJWT(response.JWT)
  } else {
    throw new Error(RETRY_LATER)
  }
  
  return response.JWT  
}

/**
 * 
 * @returns {string} JWT token
 */
export const generateNewToken = async () => {
  const skpApiSettings = await getFireStoreSkpApiSettings()
  const loginHeaders = skpApiSettings.data().loginHeaders
  const apiUrl = skpApiSettings.data().skpApiWsgBaseUrl + skpApiSettings.data().endpoints.login
  const response = await invokeWsgRequest(HTTP_POST, apiUrl, {}, {}, loginHeaders)
  if ('JWT' in response && !('errors' in response)) {
    setSkpApiJWT(response.JWT)
  } else {
    throw new Error(RETRY_LATER)
  }
  return response.JWT
}
